import { render } from "./WelcomeTestConnection.vue?vue&type=template&id=34c200bd&scoped=true"
import script from "./WelcomeTestConnection.vue?vue&type=script&lang=js"
export * from "./WelcomeTestConnection.vue?vue&type=script&lang=js"

import "./WelcomeTestConnection.vue?vue&type=style&index=0&id=34c200bd&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c200bd"]])

export default __exports__